import styles from './index.module.css';

import { CheckBox } from '../CheckBox';

interface Props {
  checked?: boolean;
  label: string;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
}

export function Boolean(props: Props) {
  const { checked, label, saveFieldValue, updateFieldValue } = props;

  return (
    <div className={styles.Boolean}>
      <CheckBox
        checked={checked}
        label={label}
        saveFieldValue={saveFieldValue}
        updateFieldValue={updateFieldValue}
      />
    </div>
  );
}
